import { CommonApiResponse } from "../../Controllers/Types/ApiResponse";
import {
  AssignContact,
  CreateTaskArray,
  mapTaskCarryForwardReasons,
  TaskCarryForwardReason,
} from "../../Controllers/Types/Task/TaskInterface";
import {
  ProjectResponse,
  TaskResponse,
} from "../../Controllers/Types/Task/TaskResponse";
import apiClient from "../apiClient";
import { baseURL } from "../ApiConstant";

const getAuthHeaders = () => {
  const token = localStorage.getItem("token");

  return {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: `Bearer ${token}`,
  };
};

const getMultipartAuthHeaders = () => {
  const token = localStorage.getItem("token");

  return {
    Accept: "application/json",
    Authorization: `Bearer ${token}`,
  };
};

export const taskProjectGetDataApi = async (): Promise<ProjectResponse> => {
  try {
    const response = await fetch(`${baseURL}/api/all-project/by-user-id`, {
      method: "GET",
      headers: getAuthHeaders(),
    });

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200, data: data["data"] };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return { status: false, statusCode: 422, massage: "Body error" };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

export const taskPartGetDataApi = async (): Promise<TaskResponse> => {
  try {
    const response = await fetch(`${baseURL}/api/task`, {
      method: "GET",
      headers: getAuthHeaders(),
    });

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200, data: data["data"] };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return { status: false, statusCode: 422, massage: "Body error" };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

export const getAllTask = async () => {
  try {
    const response = await apiClient.get(`/api/task`);

    if (response.status === 200) {
      return { status: true, body: response.data };
    }

    return { status: false, error: "failed" };
  } catch (error: any) {
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

export const taskPartCreateApi = async (
  project_reference: string | null,
  task: CreateTaskArray[]
): Promise<CommonApiResponse> => {
  try {
    const response = await fetch(`${baseURL}/api/task/create`, {
      method: "POST",
      headers: getAuthHeaders(),
      body: JSON.stringify({ project_reference, task }),
    });

    const data = await response.json();

    if (response.status === 200) {
      return {
        status: true,
        statusCode: 200,
        massage: data["massage"] ?? data["message"] ?? "Task created.",
      };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: data["massage"] ?? "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

export const taskPartUpdateApi = async (
  task_id: number | null,
  project_reference: string | null,
  task_name: string,
  hours: number,
  minute: number,
  description: string | null,
  deu_date: string,
  priority: string,
  assign: AssignContact[]
): Promise<CommonApiResponse> => {
  try {
    const response = await fetch(`${baseURL}/api/task/update/${task_id}`, {
      method: "PUT",
      headers: getAuthHeaders(),
      body: JSON.stringify({
        project_reference,
        task_name,
        description,
        deu_date,
        priority,
        hours,
        minute,
        assign,
      }),
    });

    const data = await response.json();

    if (response.status === 200) {
      return {
        status: true,
        statusCode: 200,
        massage: data["massage"] ?? data["message"] ?? "Task updated.",
      };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: data["massage"] ?? "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

export const taskPartDeleteApi = async (
  task_id: number | null
): Promise<CommonApiResponse> => {
  try {
    const response = await fetch(`${baseURL}/api/task/delete/${task_id}`, {
      method: "DELETE",
      headers: getAuthHeaders(),
    });

    const data = await response.json();

    if (response.status === 200) {
      return {
        status: true,
        statusCode: 200,
        massage: data["massage"] ?? data["message"] ?? "Deleted successfully.",
      };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: data["massage"] ?? "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

export const taskPartStatusChangedApi = async (
  task_id: number | string | null,
  status?: "Pending" | "Ongoing" | "Completed" | string
): Promise<CommonApiResponse> => {
  try {
    const response = await fetch(`${baseURL}/api/task/status-change/${task_id}`, {
      method: "POST",
      headers: getAuthHeaders(),
      body: JSON.stringify({
        status,
      }),
    });

    const data = await response.json();

    if (response.status === 200) {
      return {
        status: true,
        statusCode: 200,
        massage: data["massage"] ?? data["message"] ?? "Task status changed.",
      };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: data["massage"] ?? data["message"] ?? "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return {
        status: false,
        statusCode: response.status,
        massage: data["massage"] ?? data["message"] ?? "Error",
      };
    }
  } catch (error) {
    return {
      status: false,
      statusCode: 500,
      massage: "Oops! Connection.",
    };
  }
};

export const taskPartChangeStatusApi = async (
  task_id: number | string | null,
  status: "Pending" | "Ongoing" | "Completed" | string
): Promise<CommonApiResponse> => {
  return taskPartStatusChangedApi(task_id, status);
};

export const taskPartGetTaskContactsApi = async (
  date: string
): Promise<{
  status: boolean;
  statusCode: number;
  data: AssignContact[];
  massage?: string;
}> => {
  try {
    const response = await fetch(`${baseURL}/api/task/search-data`, {
      method: "POST",
      headers: getAuthHeaders(),
      body: JSON.stringify({
        date,
      }),
    });

    const data = await response.json();

    if (response.status === 200) {
      const responseData = data?.data ?? data;

      const list = Array.isArray(responseData)
        ? responseData
        : responseData?.contacts ??
          responseData?.assign_contacts ??
          responseData?.task_contacts ??
          responseData?.assign ??
          [];

      return {
        status: true,
        statusCode: 200,
        data: list,
        massage:
          data["massage"] ??
          data["message"] ??
          "Task contacts loaded successfully.",
      };
    } else if (response.status === 401) {
      return {
        status: false,
        statusCode: 401,
        data: [],
        massage: "Unauthorized",
      };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        data: [],
        massage: data["massage"] ?? data["message"] ?? "Body error",
      };
    } else if (response.status === 404) {
      return {
        status: false,
        statusCode: 404,
        data: [],
        massage: "Not found",
      };
    }

    return {
      status: false,
      statusCode: response.status,
      data: [],
      massage: data["massage"] ?? data["message"] ?? "Error",
    };
  } catch (error) {
    return {
      status: false,
      statusCode: 500,
      data: [],
      massage: "Oops! Connection.",
    };
  }
};

export const completeTaskWithEvidenceApi = async (
  taskId: number | string,
  note: string,
  evidenceFile: File | null
): Promise<CommonApiResponse> => {
  try {
    const formData = new FormData();

    formData.append("task_id", taskId.toString());
    formData.append("note", note ?? "");

    if (evidenceFile) {
      formData.append("file_path", evidenceFile);
    }

    const response = await fetch(
      `${baseURL}/api/task/status-change/${taskId}`,
      {
        method: "POST",
        headers: getMultipartAuthHeaders(),
        body: formData,
      }
    );

    const data = await response.json();

    if (response.status === 200) {
      return {
        status: true,
        statusCode: 200,
        massage:
          data["message"] ??
          data["massage"] ??
          "Task completed successfully.",
      };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: data["message"] ?? data["massage"] ?? "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    }

    return {
      status: false,
      statusCode: response.status,
      massage: data["message"] ?? data["massage"] ?? "Error",
    };
  } catch (error) {
    return {
      status: false,
      statusCode: 500,
      massage: "Oops! Connection.",
    };
  }
};

export const requestTaskFollowUpApi = async (
  taskId: number | string,
  note: string,
  followupDate: string
): Promise<CommonApiResponse> => {
  try {
    const response = await fetch(`${baseURL}/api/task-followup-add`, {
      method: "POST",
      headers: getAuthHeaders(),
      body: JSON.stringify({
        task_id: taskId.toString(),
        followup_date: followupDate,
        note,
      }),
    });

    const data = await response.json();

    if (response.status === 200) {
      return {
        status: true,
        statusCode: 200,
        massage:
          data["massage"] ??
          data["message"] ??
          "Follow-up requested successfully.",
      };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: data["massage"] ?? data["message"] ?? "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    }

    return {
      status: false,
      statusCode: response.status,
      massage: data["massage"] ?? data["message"] ?? "Error",
    };
  } catch (error) {
    return {
      status: false,
      statusCode: 500,
      massage: "Oops! Connection.",
    };
  }
};

export const getCarryForwardReasonListApi = async (): Promise<{
  status: boolean;
  statusCode: number;
  data: TaskCarryForwardReason[];
  massage?: string;
}> => {
  try {
    const token = localStorage.getItem("token");

    const response = await fetch(
      `${baseURL}/api/task-carry-forward-reason-list`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const data = await response.json();

    if (response.status === 200) {
      const list = Array.isArray(data) ? data : data["data"] ?? [];

      return {
        status: true,
        statusCode: 200,
        data: mapTaskCarryForwardReasons(list),
      };
    }

    return {
      status: false,
      statusCode: response.status,
      data: [],
      massage: data["massage"] ?? data["message"] ?? "Error",
    };
  } catch (error) {
    return {
      status: false,
      statusCode: 500,
      data: [],
      massage: "Oops! Connection.",
    };
  }
};

export const createCarryForwardTaskApi = async (
  taskId: number | string,
  carryForwardId: number | string
): Promise<CommonApiResponse> => {
  try {
    const response = await fetch(`${baseURL}/api/task-carry-forward-add`, {
      method: "POST",
      headers: getAuthHeaders(),
      body: JSON.stringify({
        task_id: taskId.toString(),
        carry_forward_id: carryForwardId,
      }),
    });

    const data = await response.json();

    if (response.status === 200) {
      return {
        status: true,
        statusCode: 200,
        massage:
          data["massage"] ??
          data["message"] ??
          "Carry forward requested successfully.",
      };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: data["massage"] ?? data["message"] ?? "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    }

    return {
      status: false,
      statusCode: response.status,
      massage: data["massage"] ?? data["message"] ?? "Error",
    };
  } catch (error) {
    return {
      status: false,
      statusCode: 500,
      massage: "Oops! Connection.",
    };
  }
};

export const getUserValuableTaskSummaryApi = async (
  input: any
): Promise<{
  status: boolean;
  statusCode: number;
  data?: any;
  massage?: string;
}> => {
  try {
    const token = localStorage.getItem("token");

    const response = await fetch(`${baseURL}/api/remaining-work/hours`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(input),
    });

    const data = await response.json();


    if (response.status === 200) {
      return {
        status: true,
        statusCode: 200,
        data,
        massage: data["massage"] ?? data["message"] ?? "",
      };
    }

    return {
      status: false,
      statusCode: response.status,
      data,
      massage: data["massage"] ?? data["message"] ?? "Unable to get summary.",
    };
  } catch (error) {
    return {
      status: false,
      statusCode: 500,
      massage: "Oops! Connection.",
    };
  }
};